export enum FlexDirection {
	ROW = 'row',
	COLUMN = 'column',
}

export enum FlexJustification {
	CENTER = 'center',
	START = 'start',
	END = 'end',
}
